/*
 * Copyright 2019 Red Hat, Inc. and/or its affiliates.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as React from "react";
import { VhvNotification, VhvStackedNotifications } from "@vhv/ui-kit-react";
import { MessageHelper } from "./MessageHelper";
const { Position } = require("@vhv/ui-kit/dist/collection/utils/utils");
const { NotificationLevel } = require("@vhv/ui-kit/dist/collection/components/vhv-notification/vhv-notification-level");
export class ContentAlert extends React.Component {
    constructor(props) {
        super(props);
        this.hideAlert = (key) => {
            this.setState({ alerts: [...this.state.alerts.filter(el => el.key !== key)] });
        };
        this.getUniqueId = () => new Date().getTime();
        this.postAlert = (level, message, params) => {
            const alerts = this.state.alerts;
            const key = this.getUniqueId();
            alerts.push({ key, message: MessageHelper.localize(message, params), level });
            this.setState({ alerts });
            if (level !== NotificationLevel.ERROR) {
                setTimeout(() => this.hideAlert(key), 8000);
            }
        };
        this.state = {
            alerts: []
        };
        ContentAlert.instance = this;
    }
    static success(message, params) {
        ContentAlert.instance.postAlert(NotificationLevel.SUCCESS, message, params);
    }
    static danger(message, params) {
        ContentAlert.instance.postAlert(NotificationLevel.ERROR, message, params);
    }
    static warning(message, params) {
        ContentAlert.instance.postAlert(NotificationLevel.WARNING, message, params);
    }
    static info(message, params) {
        ContentAlert.instance.postAlert(NotificationLevel.INFO, message, params);
    }
    render() {
        return React.createElement(VhvStackedNotifications, { "aria-live": "assertive" }, this.state.alerts.map(({ key, level, message }) => (React.createElement(VhvNotification, { closable: true, "close-on-escape": true, "aria-details": message, level: level, text: message, position: Position.BOTTOM_RIGHT, key: key }))));
    }
}
